import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { TDropdown } from 'src/app/project/components/dropdown/dropdown.consts';
import { TAccountSimpleResponse } from '@project/view-models';
import { TUser } from 'src/app/project/modules/user/user.model';
import { TAccountSettingsDropdownData } from './account-settings-dropdown.model';

import { DropdownService } from 'src/app/project/components/dropdown/dropdown-service/dropdown.service';
import { SidePanelService } from 'src/app/project/modules/layout/side-panel/side-panel.service';
import { UserService } from 'src/app/project/modules/user/user.service';

import { GET_SIDE_PANEL_SERVICE } from 'src/app/project/modules/layout/side-panel/side-panel-store';
import { logEventInGTAG } from 'src/app/project/services/analytics/google-analytics';
import {
  EGoogleEventCategory,
  EGoogleEventSiteList,
} from 'src/app/project/services/analytics/google-analytics.consts';
import { SidePanelSitesListService } from '../../layout/side-panel-sites-list/side-panel-sites-list.service';
import { EUserRole } from '../../share/share-utils/user-roles';

@Component({
    selector: 'pp-account-settings-dropdown',
    templateUrl: './account-settings-dropdown.component.html',
    styleUrls: ['./account-settings-dropdown.component.scss'],
    standalone: false
})
export class AccountSettingsDropdownComponent implements OnInit {
  dropdown: TDropdown<TAccountSettingsDropdownData>;
  user: TUser;
  account: TAccountSimpleResponse;
  isAccountAdmin: boolean;
  private SidePanelService: SidePanelService;

  constructor(
    private dropdownService: DropdownService,
    private router: Router,
    private userService: UserService,
    private sidePanelSitesListService: SidePanelSitesListService,
  ) {}

  ngOnInit() {
    this.dropdown = this.dropdownService.getDropdown();

    if (!this.dropdown.data) {
      throw new Error('Data for this dropdown is required');
    }

    this.user = this.userService.getUser();
    this.account = this.dropdown.data.account;
    this.SidePanelService = GET_SIDE_PANEL_SERVICE();

    this.checkIfIsAccountAdmin();
  }

  hideDropdown(): void {
    this.dropdownService.hideDropdown();
  }

  openAccountSettings(): void {
    this.SidePanelService.collapsePanel();

    logEventInGTAG(EGoogleEventSiteList.SITE_LIST_ACCOUNT_SETTINGS, {
      source: EGoogleEventCategory.SITE_LIST,
    });

    this.hideDropdown();

    this.router.navigate(['/settings/account', this.account.id]);
  }

  createNewFolder(): void {
    this.sidePanelSitesListService.createNewFolder(this.account.id);

    this.hideDropdown();
  }

  private checkIfIsAccountAdmin(): void {
    this.isAccountAdmin = this.account.workspaces.some((workspace) => {
      return workspace.shareOption === EUserRole.ACCOUNT_ADMIN;
    });
  }
}
